import {
  CREATE_LABOUR_SUCCESS,
  FETCH_LABOUR_SUCCESS,
  GET_LABOUR_SUCCESS,
  SAVE_LABOUR_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_LABOUR_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_LABOUR_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;
      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_LABOUR_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_LABOUR_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }
    default:
      return state;
  }
}
